import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { auth } from "../firebaseConfig";

const initialState = {
  email: null,
  displayName: null,
  roles: null as string[] | null,
};

const removeUser = createAsyncThunk("user/removeUser", async () => {
  await auth.signOut();
});

const userSlice = createSlice({
  name: "user",
  initialState: { ...initialState },
  reducers: {
    setUser(state, action) {
      const { email, displayName, roles } = action.payload;
      state.email = email;
      state.displayName = displayName;
      state.roles = roles || [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(removeUser.fulfilled, () => {
      return { ...initialState };
    });
  },
});

export { removeUser };
export const userActions = userSlice.actions;

export default userSlice;
